import React, { useContext, useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { fetch_orders, get_user_details } from '../api/api';
import { Link, useLocation } from 'react-router-dom';
import { MyContext } from '../context/Context';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import Loader from '../Loader/Loader';
import DateRange from '../components/DateRange';
const { RangePicker } = DatePicker;

function Orders() {
    const [orderList, setOrderList] = useState([]);
    const [viewOrder, setViewOrder] = useState({});
    const { loader, setLoader, dateFormate } = useContext(MyContext)
    // const [customerName, setCustomerName] = useState({
    //     firstname: '',
    //     lastname: ''
    // });
    const [dateFilter, setDateFilter] = useState({
        start_date: '',
        end_date: ''
    })
    const [isFiltered, setIsFiltered] = useState(false);
    const add_close_Ref = useRef(null);
    const [statusFilter, setStatusFilter] = useState('');

    const location = useLocation();
    const userId = location.state?.userId;

    // const [tomorrowFilterDate, setTomorrowFilterDate] = useState(location.state?.tomorrowOrder == 'tomorrow-day' ? true : false);
    // const tomorrow = tomorrowFilterDate
    //     ? new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
    //     : new Date().toISOString().slice(0, 10);

    const [thisMonthFilterData, setThisMonthFilterData] = useState(location.state?.thisMonthOrder === 'this-month' ? true : false);
    const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().slice(0, 10);
    const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1).toISOString().slice(0, 10);

    const thisMonth = thisMonthFilterData
        ? { start: firstDayOfMonth, end: lastDayOfMonth }
        : { start: new Date().toISOString().slice(0, 10), end: new Date().toISOString().slice(0, 10) };


    // console.log(thisMonth)

    useEffect(() => {
        fetch_all_orders(dateFilter.start_date, dateFilter.end_date, thisMonthFilterData);
    }, [statusFilter])


    const viewOrderDetails = async (id) => {
        const order = orderList?.filter((data) => data.order_id === id);
        setViewOrder(order[0]);

        // try {
        //     const res = await get_user_details({ user_id: order[0].user_id })
        //     if (res.status === 200) {
        //         setCustomerName({ ...customerName, firstname: res.data.data[0].firstname, lastname: res.data.data[0].lastname });
        //     }
        // } catch (error) {
        //     console.error("User Api error:", error);
        // }
    }

    const fetch_all_orders = async (startDate, endDate, thisMonthFilterData) => {
        const filter = {}
        if (startDate && endDate) {
            filter.start_date = startDate;
            filter.end_date = endDate;
        }


        if (thisMonthFilterData) {
            filter.start_date = thisMonth.start
            filter.end_date = thisMonth.end;
            setDateFilter({
                start_date: thisMonth.start,
                end_date: thisMonth.end
            });
            setIsFiltered(true)
        }


        filter.user_id = userId ? userId : "";
        filter.order_status = statusFilter ? statusFilter : ""

        setLoader(true);
        try {
            const res = await fetch_orders(filter);
            if (res.status === 200) {
                setOrderList(res.data.data);
            }
            setLoader(false);
        } catch (error) {
            console.error("Order List Api error:", error);
        }
    };


    const handleFilter = (dates, dateStrings) => {
        if (dateStrings[0] && dateStrings[1]) {
            // If both dates are selected, apply filter
            setDateFilter({
                start_date: moment(dateStrings[0]).format('YYYY-MM-DD'),
                end_date: moment(dateStrings[1]).format('YYYY-MM-DD'),
            });
        } else {
            // If no dates are selected, reset filter
            setDateFilter({ start_date: '', end_date: '' });
            if (isFiltered) {
                fetch_all_orders('', '');
                setIsFiltered(false);
            }
        }
    };

    const onFocus = () => {
        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
            setDateFilter({ start_date: '', end_date: '' });  // Reset state when focus happens
        }
    }

    const applyFilter = () => {
        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
            setIsFiltered(true);
            fetch_all_orders(dateFilter.start_date, dateFilter.end_date);
        }

    }

    // data table 
    useEffect(() => {
        const tableId = '#example2';
        const table = $(tableId);

        // Only initialize DataTable if orderList is not empty
        if (orderList.length > 0) {
            // Destroy any existing DataTable instance before initializing a new one
            if ($.fn.DataTable.isDataTable(tableId)) {
                table.DataTable().destroy();
            }

            // Initialize DataTable with scrollX for horizontal scrolling
            table.DataTable({
                paging: true,
                lengthChange: true,
                pageLength: 10,
                lengthMenu: [5, 10, 15, 20],
                searching: true,
                ordering: false,
                info: true,
                autoWidth: false,
                infoFiltered: "(filtered from _MAX_ total records)",
                pagingType: 'full_numbers', // Pagination with full numbers
                language: {
                    paginate: {
                        first: '«',
                        last: '»',
                        next: '›',
                        previous: '‹',
                    }
                },
                drawCallback: function (settings) {
                    const api = this.api();
                    const info = api.page.info();
                    const $paginate = $(tableId + '_paginate').find('span a.paginate_button');
                    const currentPage = info.page;
                    const totalPages = info.pages;

                    // Show only specific pages with ellipses
                    $paginate.each(function (index) {
                        const pageIndex = parseInt($(this).text(), 10) - 1;
                        if (isNaN(pageIndex)) return; // Skip non-number buttons

                        if (
                            pageIndex === 0 ||
                            pageIndex === totalPages - 1 ||
                            (pageIndex >= currentPage - 1 && pageIndex <= currentPage + 1)
                        ) {
                            $(this).show();
                        } else {
                            $(this).hide();
                        }
                    });

                    // Add ellipses if necessary
                    if (currentPage > 2) {
                        $('<span class="paginate_button ellipsis">...</span>').insertAfter($paginate.eq(0));
                    }
                    if (currentPage < totalPages - 3) {
                        $('<span class="paginate_button ellipsis">...</span>').insertBefore($paginate.eq(totalPages - 1));
                    }
                }
            });
        }

        return () => {
            if ($.fn.DataTable.isDataTable(tableId)) {
                table.DataTable().destroy();
            }
        };
    }, [orderList]);



    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0">Orders</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Orders</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    loader ? <Loader /> : (

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">Orders List</h3>
                                            </div>
                                            <div className="card-body">

                                                <div className='d-flex flex-column flex-md-row align-items-center mb-3'>
                                                    <div className='row mb-3 d-flex align-items-center'>
                                                        <div className='mr-2'>Date :</div>
                                                        <div className='mr-3'>

                                                            <DateRange handleFilter={handleFilter} onFocus={onFocus} value={[
                                                                dateFilter.start_date ? moment(dateFilter.start_date) : '',
                                                                dateFilter.end_date ? moment(dateFilter.end_date) : '',
                                                            ]} />


                                                        </div>
                                                        <div className='mr-4 mt-3 mt-sm-0'>
                                                            <button
                                                                type="button"
                                                                className="btn btn-naariyal-green"
                                                                onClick={applyFilter}
                                                            >
                                                                Filter
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className='mb-3 mr-4 d-flex align-items-center'>
                                                        <div className='mr-2'>
                                                            Status :
                                                        </div>
                                                        <div >
                                                            <select
                                                                className="custom-select"
                                                                name="status"
                                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                                value={statusFilter}
                                                            >
                                                                <option value="">All</option>
                                                                <option value="incomplete">Incomplete</option>
                                                                <option value="complete">Complete</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='table-responsive'>
                                                    <table id="example2" className="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Order No</th>
                                                                <th>Quantity</th>
                                                                <th>Subscription</th>
                                                                <th>Date</th>
                                                                <th>Total</th>
                                                                <th>Status</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                orderList.length > 0 ?
                                                                    orderList.map((order, index) => (
                                                                        <tr key={index}>
                                                                            <td>{order.order_no}</td>
                                                                            <td>{order.total_quantity}</td>
                                                                            <td>{order.subscription_type}</td>
                                                                            <td>{dateFormate(order.start_date)} - {dateFormate(order.end_date)}</td>
                                                                            <td>{order.order_total}</td>
                                                                            <td>
                                                                                {(() => {
                                                                                    if (order.order_status === "incomplete") {
                                                                                        return <span className="badge badge-warning text-sm">Incomplete</span>;
                                                                                    } else if (order.order_status === "complete") {
                                                                                        return <span className="badge badge-success text-sm">Complete</span>;
                                                                                    }
                                                                                })()}
                                                                            </td>
                                                                            <td style={{ width: "205px" }}>
                                                                                <div className="btn-group">
                                                                                    <button type="button" className="btn btn-naariyal-green dropdown-toggle" data-toggle="dropdown">Action</button>
                                                                                    <div className="dropdown-menu" role="menu">
                                                                                        <a
                                                                                            className="dropdown-item text-info"
                                                                                            data-toggle="modal"
                                                                                            data-backdrop="static"
                                                                                            data-target="#orderDetails"
                                                                                            onClick={() => viewOrderDetails(order.order_id)}

                                                                                        >
                                                                                            <i className="nav-icon fa-solid fa-book mr-2"></i>
                                                                                            Order Details
                                                                                        </a>
                                                                                        <div className="dropdown-divider"></div>

                                                                                        <Link
                                                                                            to="/sub-orders"
                                                                                            state={{
                                                                                                orderId: order.order_id
                                                                                            }}
                                                                                            className="dropdown-item text-info"

                                                                                        >
                                                                                            <i className="nav-icon fa-solid fa-list-check mr-2"></i>
                                                                                            Sub Orders
                                                                                        </Link>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                    : <tr>
                                                                        <td colSpan={7}>
                                                                            <span>
                                                                                No data available
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* Order details */}
                            <div className="modal fade pr-0" id="orderDetails" tabIndex={-1} role="dialog" aria-labelledby="orderDetailsModal" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header border-0">
                                            <h5>Order Details</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={add_close_Ref}>
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="input-group">

                                                <div className='w-100 mb-3 d-flex '>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Customer name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='customer_name'
                                                            value={viewOrder.customer?.firstname ? viewOrder.customer?.firstname + ' ' + viewOrder.customer?.lastname : '-'}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className=''>
                                                        <label htmlFor="area_name">Mobile no</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='item_name'
                                                            value={viewOrder.customer?.mobile_no ? viewOrder.customer?.mobile_no : '-'}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                                <div className='w-100 mb-3 d-flex '>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Order No</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='order_no'
                                                            value={viewOrder.order_no ? viewOrder.order_no : '-'}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className=''>
                                                        <label htmlFor="area_name">Item Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='item_name'
                                                            value={viewOrder.item_name ? viewOrder.item_name : '-'}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Quantity</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='quantity'
                                                            value={viewOrder.quantity ? viewOrder.quantity : '-'}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="area_name">Price</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='item_price'
                                                            value={viewOrder.item_price ? viewOrder.item_price : '-'}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Total Quantity</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='total_quantity'
                                                            value={viewOrder.total_quantity ? viewOrder.total_quantity : '-'}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className=''>
                                                        <label htmlFor="area_name">Total</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='order_total'
                                                            value={viewOrder.order_total ? viewOrder.order_total : '-'}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Subscription</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='subscription_type'
                                                            value={viewOrder.subscription_type ? viewOrder.subscription_type : '-'}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className=''>
                                                        <label htmlFor="area_name">Date</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name='start_date'
                                                            value={`${viewOrder.start_date} / ${viewOrder.end_date}`}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>


                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="area_name">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name='order_status'
                                                        value={viewOrder.order_status ? viewOrder.order_status : '-'}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='w-100'>
                                                    <label htmlFor="area_name">Address</label>
                                                    <textarea
                                                        type=""
                                                        className="form-control"
                                                        name='delivery_address'
                                                        value={viewOrder.delivery_address ? viewOrder.delivery_address : '-'}
                                                        disabled
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                        <div className="modal-footer border-0">

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    )
                }

            </div >

            <Footer />
            <aside className="control-sidebar control-sidebar-dark"></aside>
        </div >
    );
}

export default Orders;
